export default __webpack_public_path__ + "static/media/day.cd6648ba.svg";